import { useNavigate } from 'react-router-dom'
import './Module.scss'

const ModuleComponent = (props: { icon: string, name: string, route: string, disabled: boolean, resize?: boolean }) => {
    const navigate = useNavigate()
    const OnClickModule = (route: string) => {
        navigate(`/${route}`)
    }

    return (
        <div className={`${props.disabled ? 'CardModule_disabled' : 'CardModule'} `} onClick={() => props.disabled ? null : OnClickModule(props.route)}>
            <img src={props.icon} className={`${props.resize ? 'p-3' : 'p-0'}`} style={{ width: '110px', height: '110px'}}/>
            <span>{props.name}</span>
        </div>
    )

}

export default ModuleComponent